export default "__VITE_ASSET__Dv53a3_X__"